import React, { useState } from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"
import Button from "@material-ui/core/Button"
import Hidden from "@material-ui/core/Hidden"
import Grid from "@material-ui/core/Grid"
import Box from "@material-ui/core/Box"
import styled from "styled-components"
import zIndex from "@material-ui/core/styles/zIndex"

function MenuBar() {
  const [isOpen, setOpen] = useState(false)

  const data = useStaticQuery(graphql`
    query {
      menu_open_button: file(relativePath: { eq: "menu_open_button.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      menu_close_button: file(relativePath: { eq: "menu_close_button.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      menu_logo: file(relativePath: { eq: "menu_logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      menu_right_image: file(relativePath: { eq: "menu_right_image.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <>
      <Box
        height="1vh"
        style={isOpen == true ? { display: "none" } : { position: "absolute" }}
      >
        <Button onClick={() => setOpen(!isOpen)}>
          <Box
            width="60px"
            height="78%"
            style={{
              position: "fixed",
              top: "0",
              left: "0",
              margin: "102px 21px",
            }}
          >
            <Img fluid={data.menu_open_button.childImageSharp.fluid} />
          </Box>
        </Button>
      </Box>
      <Box
        height="100vh"
        width="100vw"
        bgcolor="#F2F2F2"
        style={
          isOpen == true
            ? { position: "fixed", top: "0", zIndex: "1000" }
            : { display: "none" }
        }
      >
        <Button onClick={() => setOpen(!isOpen)}>
          <Box
            width="60px"
            height="78%"
            style={{
              position: "fixed",
              top: "0",
              left: "0",
              margin: "102px 21px",
            }}
          >
            <Img fluid={data.menu_close_button.childImageSharp.fluid} />
          </Box>
        </Button>
        <Box width="24%" height="80%">
          <Grid container style={{ height: "100%" }}>
            <Grid
              container
              direction="column"
              justify="space-around"
              alignItems="flex-start"
              style={{ height: "90%", margin: "100px 0 0 180px" }}
            >
              <Grid item>
                <FontSize size="70px" string="ABOUT" />
                <FontSize size="14px" string="UNFILTERとは" />
              </Grid>
              <Grid item>
                <FontSize size="70px" string="PRODUCTS" />
                <FontSize size="14px" string="商品詳細" />
              </Grid>
              <Grid item>
                <FontSize size="70px" string="FAQ" />
                <FontSize size="14px" string="よくある質問" />
              </Grid>
              <Grid item>
                <FontSize size="70px" string="CONTACT" />
                <FontSize size="14px" string="お問い合わせ" />
              </Grid>
              <Grid item>
                <FontSize size="70px" string="MY PAGE" />
                <FontSize size="14px" string="ログイン" />
              </Grid>
            </Grid>
            <Box
              width="180.83px"
              height="177.13px"
              style={{
                position: "fixed",
                left: "767.83px",
                top: "128.33px",
              }}
            >
              <Img fluid={data.menu_logo.childImageSharp.fluid} />
            </Box>
          </Grid>
        </Box>
        <Box
          width="30%"
          style={{
            position: "fixed",
            top: "20px",
            right: "0",
          }}
        >
          <Img fluid={data.menu_right_image.childImageSharp.fluid} />
        </Box>
      </Box>
    </>
  )
}

const FontSize = Props => {
  return (
    <>
      <p style={{ fontSize: Props.size, lineHeight: "100%" }}>{Props.string}</p>
    </>
  )
}

const MenuDrawer = () => {
  const [isOpen, setOpen] = useState(false)
  return (
    <></>
    // <Drawer
    //   anchor={"left"}
    //   open={state[anchor]}
    //   onClose={toggleDrawer(anchor, false)}
    // >
    //   {list(anchor)}
    // </Drawer>
  )
}

export default MenuDrawer
